import { useState, type ReactNode } from 'react';
import { HeaderCtx } from './headerState';

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [overHero, setOverHero] = useState(false);
  return <HeaderCtx.Provider value={{ overHero, setOverHero }}>{children}</HeaderCtx.Provider>;
}
